// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import Asset from 'core/api/common/Asset';

/**
 * Base class for a state in our animation system
 */
class AbstractState {
  constructor() {
    this._globalStartTime = 0;
    this.onFinished = null;
  }

  update() {}
  postUpdate() {}
  getCurrentSourceData() {}

  resetClips(globalTime) {
    this._globalStartTime = globalTime;
  }

  shiftClipTime(shiftTime) {
    this._globalStartTime += shiftTime;
  }

  /**
   * Gets the internal api Asset object for a specified public api AnimationState object.
   *
   * @param {Asset} publicAsset - The public api AnimationState object.
   *
   * @return {AbstractState} The internal api AnimationState object.
   */
  static forPublicAsset(publicAsset) {
    return publicAsset._internalAsset;
  }

  /**
   * Gets the public api AnimationState object for this internal api AnimationState object.
   *
   * @return {Asset} The public api AnimationState object.
   */
  get publicAsset() {
    if(!this._publicAsset) {
      this._publicAsset = new Asset(this);
    }
    return this._publicAsset;
  }
}

export default AbstractState;
